import {combineReducers} from 'redux';

import hKReducer from "./HKReduces.js";
import outlineIdReducer from "./outlineId.js";

let Reducer = combineReducers({
	HK: hKReducer,
	outlineId: outlineIdReducer
})

export default Reducer;
